<template>
  <div class="banner">
    <div class="askPage" v-show="!askPage">
      <div class="tipsBox">
        <img :src="nextBtnImg" alt="" class="next" @click="next" @mouseenter="nextBtnChageInto" @mouseleave="nextBtnChangeOut" />
      </div>
    </div>
    <img src="../assets/img/index/机器人.gif" alt="" class="robotGif" />
    <img :src="homeBtnImg" class="homeBtn" @click="homeBack" @mouseenter="homeBtnActive" @mouseleave="homeBtn" />
    <audio ref="audioPlay" :loop="false">
      <source :src="oneAudio" type="audio/mpeg" />
    </audio>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import nextBtn from "../assets/img/reason/submitBtn.png";
import nextBtnActive from "../assets/img/reason/submitBtnActive.png";
import anime from "animejs";

import home from "../assets/img/home.png";
import homeActive from "../assets/img/homeActive.png";

import oneAudio from "../assets/audio/forecast/oneAudio.mp3";
// 高亮切换
let homeBtnImg = ref(home);
// 首页按钮切换
const homeBtnActive = () => {
  homeBtnImg.value = homeActive;
};
const homeBtn = () => {
  homeBtnImg.value = home;
};

// 是否界定问题
let askPage = ref(false);

const audioPlay = ref();

// 模组定义
const router = useRouter();

// 继续按钮值
const nextBtnImg = ref(nextBtn);
// 排名預測值
let rank01 = ref(1);
let rank02 = ref(2);
let rank03 = ref(3);

const next = async () => {
  router.push({ name: "experiment" });
  await audioPlay.value.pause();
};

const homeBack = () => {
  router.push({ name: "home" });
};

// 继续按钮 图片切换
// 进入时
const nextBtnChageInto = () => {
  nextBtnImg.value = nextBtnActive;
};
// 退出时
const nextBtnChangeOut = () => {
  nextBtnImg.value = nextBtn;
};
onMounted(async () => {
  anime({
    targets: ".tips",
    scale: [0, 1],
    duration: 800,
    easing: "linear",
  });
  setTimeout(() => {
    anime({
      targets: ".next",
      opacity: [0, 1],
      duration: 800,
      easing: "linear",
    });
  }, 800);
  await audioPlay.value.play();
});
</script>
<style scoped lang="scss">
.banner {
  margin: 0px;
  padding: 0px;
  width: 100vw;
  height: 100vh;
  position: relative;
  background-image: url(../assets/img/double/background.png);
  background-size: 100% 100%;
  .askPage {
    width: 100%;
    height: 100%;
    position: absolute;
    background-image: url(../assets/img/double/background.png);
    background-size: 100% 100%;
    z-index: 9;
    .tipsBox {
      position: absolute;
      top: 28vh;
      left: 20vw;
      width: 58vw;
      height: 45vh;
      background-size: 100% 100%;
      background-image: url(../assets/img/forecast/tips.png);
    }
    .next {
      width: 12vw;
      position: absolute;
      top: 31.5vh;
      left: 24vw;
      opacity: 0;
    }
  }
  .forecast {
    width: 100%;
    height: 100%;
    position: absolute;
    background-image: url(../assets/img/double/background.png);
    background-size: 100% 100%;
    z-index: 9;
    .forecastBox {
      width: 58vw;
      height: 65vh;
      position: absolute;
      left: 20vw;
      top: 17vh;
      background-size: 100% 100%;
      background-image: url(../assets/img/forecast/forecastBackground.png);
      .choseBtn {
        position: absolute;
        width: 4.8vw;
      }
      .choseBtn01 {
        left: 43vw;
        top: 23.8vh;
      }
      .choseBtn02 {
        left: 47.6vw;
        top: 23.8vh;
      }
      .choseBtn03 {
        left: 43vw;
        top: 38vh;
      }
      .choseBtn04 {
        left: 47.6vw;
        top: 38vh;
      }
      .nextBtn {
        position: absolute;
        bottom: 10vh;
        left: 23vw;
        width: 13vw;
      }
    }
  }
  .rankAllBox {
    position: absolute;
    top: 15.5vh;
    left: 23.5vw;
    width: 55.2vw;
    height: 66vh;
    background-image: url(../assets/img/forecast/forecListBackground.png);
    background-size: 100% 100%;
    .rank {
      font-size: 48px;
    }
    .rankBox {
      position: relative;
      width: 9.7vw;
      height: 6vh;
      z-index: 1;
      text-align: center;
      color: #fff;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
    .rankBox01 {
      top: 42vh;
      left: 16.5vw;
    }
    .rankBox02 {
      top: 36vh;
      left: 29.1vw;
      width: 10vw;
    }
    .rankBox03 {
      width: 9vw;
      top: 30vh;
      left: 41.5vw;
    }
    .nextBtn {
      width: 13vw;
      position: absolute;
      bottom: 7vh;
      right: 19.5vw;
      box-sizing: border-box;
      text-align: center;
    }
  }
  .homeBtn {
    position: absolute;
    bottom: 3vh;
    right: 3vw;
    width: 4vw;
    z-index: 9;
  }
  .robotGif {
    position: absolute;
    top: 48vh;
    left: 0vw;
    width: 25vw;
    z-index: 9;
  }
}
</style>
